<!-- 
    Testkomponente für das Routing
-->

<template>
    <div class="detail-card container">
        <div>child3-widget</div>
        <div class="field">
            <div class="label">Param for Link</div>
            <div class="value">
                <QInput outlined type="textarea" v-model="newParam" :height="80" />
            </div>
        </div>
        <router-link class="router-link" :to="getPathToChild3()">
            <QitButton label="Child3-Route" />
        </router-link>
        <router-link class="router-link" :to="getPathToChild3Root()">
            <QitButton label="Child3-As-Root-Route" />
        </router-link>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import QitButton from "@/shared/components/buttons/qit-button.vue";
import { QInput } from "quasar";
import { useAbilityRoute } from "@/shared/environment/ability-route";

const newParam = ref("<leer>");

const { getPathToChild, getPathToChildWithoutParents } = useAbilityRoute();

function getPathToChild3() {
    return getPathToChild("playGroundChild3", { playGroundChild3: newParam.value });
}

function getPathToChild3Root() {
    return getPathToChildWithoutParents("playGroundChild3", { playGroundChild3: newParam.value });
}
</script>

<style lang="scss" scoped>
.container {
    display: flex;
    gap: $spacing-m;
    padding: $spacing-m;
}
</style>
